import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Badge } from '../ui/badge';
import { obPreview, inr } from './api';

function PreviewTable({ data, kind }) {
  if (!data) return <div className="text-xs text-muted-foreground p-4">Loading…</div>;
  const actual = data.rows.filter(r => r.rate_source === 'VENDOR_INVOICE').length;
  return (
    <div>
      <div className="flex gap-4 text-xs mb-2" data-testid={`preview-summary-${kind}`}>
        <span>{data.total} lines</span><span>Total {inr(data.total_value)}</span>
        <span className="text-green-700">{actual} at actual rate</span><span className="text-amber-700">{data.total - actual} at estimate</span>
      </div>
      <div className="max-h-[55vh] overflow-auto">
        <table className="w-full text-xs">
          <thead className="text-left border-b sticky top-0 bg-background"><tr><th className="p-1">Item</th><th className="text-right">Est. Qty</th><th className="text-right">Opening Qty</th><th className="text-right">Est. Rate</th><th className="text-right">Rate Used</th><th className="text-right">Value</th><th>Source</th></tr></thead>
          <tbody>
            {data.rows.map(r => (
              <tr key={r.commercial_line_id} className="border-b" data-testid={`preview-row-${r.commercial_line_id}`}>
                <td className="p-1">{r.description}</td>
                <td className="text-right">{r.estimated_quantity ?? '—'}</td>
                <td className="text-right font-medium">{r.quantity ?? '—'}</td>
                <td className="text-right">{r.estimated_rate != null ? inr(r.estimated_rate) : '—'}</td>
                <td className="text-right font-medium">{r.rate != null ? inr(r.rate) : '—'}</td>
                <td className="text-right">{inr(r.final_amount)}</td>
                <td>{r.rate_source === 'VENDOR_INVOICE'
                  ? <Badge className="bg-green-100 text-green-800 text-[10px]" title={(r.vendor_invoice_numbers || []).join(', ')}>Actual</Badge>
                  : <Badge variant="outline" className="text-[10px]">Estimate</Badge>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function OpeningValuePreview({ token, oid, onClose }) {
  const [asset, setAsset] = useState(null);
  const [inv, setInv] = useState(null);
  useEffect(() => {
    obPreview(token, 'asset', oid).then(setAsset);
    obPreview(token, 'inventory', oid).then(setInv);
  }, [token, oid]);
  return (
    <Dialog open onOpenChange={o => !o && onClose()}>
      <DialogContent className="max-w-4xl" data-testid="opening-value-preview">
        <DialogHeader><DialogTitle>Opening Register Values — Estimate vs Actual</DialogTitle></DialogHeader>
        <Tabs defaultValue="asset">
          <TabsList><TabsTrigger value="asset" data-testid="preview-tab-asset">Assets</TabsTrigger><TabsTrigger value="inventory" data-testid="preview-tab-inventory">Inventory</TabsTrigger></TabsList>
          <TabsContent value="asset"><PreviewTable data={asset} kind="asset" /></TabsContent>
          <TabsContent value="inventory"><PreviewTable data={inv} kind="inventory" /></TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
